module.exports = __webpack_public_path__ + "static/gold_btn_somali-1545c2a88c3fcb5b1f96.png";